var filterDeleteTimer;

$(function () {

    /**
     * Deleting picture gallery article filter
     */
    $('span.delete-filter').on('click', function () {

        loading('show');

        // get
        var filter = $(this).attr('data-filter');

        if (filterDeleteTimer) {
            clearTimeout(filterDeleteTimer);
        }
        $(this).parent().hide();

        var filters = $('span.delete-filter:visible').map(function () {
            return $(this).attr('data-filter');
        });

        filterDeleteTimer = setTimeout(function () {
            var url = window.location.href.split('?');

            if (typeof filters !== 'undefined' && filters.length) {
                var new_param = [];
                var params = url[1];
                var queries = params.split('&');

                $.each(queries, function (k, v) {
                    var querie = v.split('=')[0];
                    if ($.inArray(querie, filters) !== -1) {
                        new_param.push(v);
                    }
                });

                new_param.join('&');
                if (new_param.length) {
                    url = url[0] + '?' + new_param.join('&');
                } else {
                    url = url[0];
                }
            } else {
                url = url[0];
            }
            let title = document.title;
            goTo(title, title, url);
        }, 2000);

    });

    /**
     * Open article modal
     */
    function openArticleModal(url)
    {

        var modalContainer = $('#article_modal_new');

        $.ajax({
            type: 'GET',
            url: url,
            success: function (data) {

                modalContainer.html(data);

                let tableRowObject = $('[data-article-href="' + url + '"]');

                let prevHref = tableRowObject.prev().data('articleHref');
                let nextHref = tableRowObject.next().data('articleHref');

                if (prevHref) {
                    $('[data-previous-modal]').attr('href', prevHref)
                } else {
                    $('[data-previous-modal]').addClass('disabled');
                }

                if (nextHref) {
                    $('[data-next-modal]').attr('href', nextHref)
                } else {
                    $('[data-next-modal]').addClass('disabled');
                }

                modalContainer.modal({'keyboard': false}, 'show');
            },

            error: function (data) {
                alert('This article modal cannot be opened because of an AJAX request error!');
            }

        });

    }

    /**
     * Click on table row triggers modal window with article details
     */
    $('body').on('click', '.js-open-article-modal', function (event) {
        event.preventDefault();
        openArticleModal($(this).attr('href'));
    });

    /**
     * Image rotating function in article modal
     */
    $('body').on('click', '.js-rotate-image', function (event) {

        event.preventDefault();

        let rotateDirection = $(this).data('rotateDirection');
        let image = $("img[data-image-id='" + $(this).data('imageId') + "']");

        $.ajax({

            type: 'GET',
            url: event.currentTarget.href,

            success: function (data) {

                // if image has been successfully rotated
                if (typeof data.image_url !== 'undefined') {


                    let degree = image.attr('data-degree');

                    if (typeof degree === 'undefined') {
                        degree = 0;
                    }

                    if (rotateDirection === 'right') {
                        degree = parseInt(degree) + 90;
                    }

                    if (rotateDirection === 'left') {
                        degree = parseInt(degree) - 90;
                    }

                    image.attr('data-degree', degree);
                    image.attr('href', data.image_url);

                    image.css({
                        'transform': 'rotate(' + degree + 'deg)',
                        'transition': 'transform .3s',
                    });

                } else {
                    alert('Error, please contact admin. ');
                }

            },

            error: function (data) {
                console.log('Error');
            }

        });

    });

    /**
     *
     */
    function checkForQueryResult() {

        let queryResultRow = $('tr.query_found');
        let queryResultFound = queryResultRow.length;
        let queryResultArticleHref = queryResultRow.data('articleHref');

        if (queryResultFound) {
            openArticleModal(queryResultArticleHref);
        }

    }

    checkForQueryResult();

});
